import { render } from "./DriverBalance.vue?vue&type=template&id=a5f19d82&scoped=true"
import script from "./DriverBalance.vue?vue&type=script&lang=js"
export * from "./DriverBalance.vue?vue&type=script&lang=js"

import "./DriverBalance.vue?vue&type=style&index=0&id=a5f19d82&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f19d82"]])

export default __exports__